<template>
  <!-- -->
  <div class="data-count">
    <div class="project-info" v-for="(item, idx) in dataList" :key="idx">
      <div class="project-info-name">
        <div class="tips"></div>
        <div class="name">{{ item.itemName }}</div>
      </div>
      <div class="project-info-value">
        <yq-number :value="item.count || 0" :length="numberLength" style="font-size: 18px" :invalid-color="invalidColor"/>
      </div>
    </div>
  </div>
</template>

<script>


import YqNumber from "@/components/YqNumber.vue";

export default {
  props: {
    dataList: {default: () => [{itemName: "作业项目", count: 15},{itemName: "作业班组", count: 10},{itemName: "工人数量", count: 5}]},
    numberLength: {default: 6},
    invalidColor: {default: "#ccc"}
  },
  name: "DC",
  components: {
    YqNumber
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.data-count{

}
</style>